export default [
  {
    path: '/',
    name: 'home',
    redirect: "/login"
  }
]
